// extracted by mini-css-extract-plugin
export var backgroundGray = "ReadMore-module--background-gray--efabc";
export var backgroundWhite = "ReadMore-module--background-white--9936f";
export var button = "ReadMore-module--button--b2958";
export var content = "ReadMore-module--content--169b0";
export var expanded = "ReadMore-module--expanded--e2856";
export var hideCloseButton = "ReadMore-module--hide-close-button--f853d";
export var onlyMobile = "ReadMore-module--only-mobile--b960a";